import React from 'react'

const Toto = (props) => {
    // console.log(props.theState.messageToto);
                                                                                    // ici nous avons passé une fonction en tant que props de l'élément parent vers l'élement enfant
    const btnReponseToto = props.theState.messageMaman !== null ? (<button onClick={props.reponseToto} className='btn btn-success'>Réponse</button>) : (<button disabled className='btn btn-success'>Réponse</button>)
    



  return (
      <div>
          <h2> {props.name} </h2>
          {btnReponseToto}
          <p className='h2 text-warning'>{props.theState.messageToto}</p>
      </div>
  )
}

export default Toto